import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const MinusCircle = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/minus-circle">
        <g id="minus-circle">
          <path
            id="Vector"
            d="M7.94792 15.1667C4.00125 15.1667 0.78125 11.9534 0.78125 8.00004C0.78125 4.04671 4.00125 0.833374 7.94792 0.833374C11.8946 0.833374 15.1146 4.04671 15.1146 8.00004C15.1146 11.9534 11.9012 15.1667 7.94792 15.1667ZM7.94792 1.83337C4.54792 1.83337 1.78125 4.60004 1.78125 8.00004C1.78125 11.4 4.54792 14.1667 7.94792 14.1667C11.3479 14.1667 14.1146 11.4 14.1146 8.00004C14.1146 4.60004 11.3479 1.83337 7.94792 1.83337Z"
          />
          <path
            id="Vector_2"
            d="M10.6146 8.5H5.28125C5.00792 8.5 4.78125 8.27333 4.78125 8C4.78125 7.72667 5.00792 7.5 5.28125 7.5H10.6146C10.8879 7.5 11.1146 7.72667 11.1146 8C11.1146 8.27333 10.8946 8.5 10.6146 8.5Z"
          />
        </g>
      </g>
    </svg>
  );
};

MinusCircle.displayName = 'MinusCircle';
